"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkIsDatesInRangeByNow = void 0;
const check_is_dates_in_range_helper_1 = require("../check-is-dates-in-range/check-is-dates-in-range.helper");
const checkIsDatesInRangeByNow = (startDate, endDate) => {
    return (0, check_is_dates_in_range_helper_1.checkIsDatesInRange)(new Date(), startDate, endDate);
};
exports.checkIsDatesInRangeByNow = checkIsDatesInRangeByNow;
